import { useEffect, useState } from "react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

const fmtKM = (n) => {
    const v = Math.round((n || 0) * 100) / 100;
    const opts = (v % 1 === 0)
        ? { maximumFractionDigits: 0 }
        : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return new Intl.NumberFormat("bs-BA", opts).format(v) + " KM";
};

export default function QuotesList({ onReuse }) {
    const [quotes, setQuotes] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const r = await fetch(`${API}/api/quotes/recent?limit=50`, { credentials: "include" });
            if (!r.ok) throw new Error();
            setQuotes(await r.json());
        } catch {
            toast.error("Greška pri učitavanju ponuda");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    const download = async (q) => {
        try {
            const r = await fetch(`${API}/api/quotes/${q.quote_id}/pdf`, { credentials: "include" });
            if (!r.ok) throw new Error("Greška pri preuzimanju");
            const blob = await r.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url; a.download = `${q.quote_number}.pdf`;
            document.body.appendChild(a); a.click(); a.remove();
            URL.revokeObjectURL(url);
        } catch (e) {
            toast.error(e.message || "Greška");
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center py-20">
                <div className="w-8 h-8 border-4 border-[hsl(var(--accent))] border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }

    if (quotes.length === 0) {
        return (
            <div className="bg-white border border-[hsl(var(--line))] p-10 text-center">
                <p className="text-[hsl(var(--muted-ink))]">Još nema napravljenih ponuda.</p>
                <p className="text-xs text-[hsl(var(--muted-ink))] mt-2">Vratite se na tab "Nova ponuda" da kreirate prvu.</p>
            </div>
        );
    }

    return (
        <div className="bg-white border border-[hsl(var(--line))]">
            <div className="p-6 border-b border-[hsl(var(--line))] flex items-center justify-between">
                <div>
                    <h2 className="text-lg font-bold">Napravljene ponude</h2>
                    <p className="text-xs text-[hsl(var(--muted-ink))] mt-1">Posljednjih {quotes.length} ponuda</p>
                </div>
                <button onClick={load} data-testid="reload-quotes-btn"
                    className="text-xs text-[hsl(var(--muted-ink))] hover:text-[hsl(var(--ink))]">
                    Osvježi
                </button>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-[hsl(var(--paper-2))] text-[hsl(var(--muted-ink))] text-[10px] tracking-widest uppercase">
                        <tr>
                            <th className="px-5 py-3 text-left">Broj</th>
                            <th className="px-5 py-3 text-left">Datum</th>
                            <th className="px-5 py-3 text-left">Kupac</th>
                            <th className="px-5 py-3 text-left">Model</th>
                            <th className="px-5 py-3 text-right">Ukupno</th>
                            <th className="px-5 py-3 text-right">Akcije</th>
                        </tr>
                    </thead>
                    <tbody>
                        {quotes.map((q) => (
                            <tr key={q.quote_id} data-testid={`quote-row-${q.quote_number}`}
                                className="border-t border-[hsl(var(--line))] hover:bg-[hsl(var(--paper-2))]">
                                <td className="px-5 py-3 font-bold">{q.quote_number}</td>
                                <td className="px-5 py-3 text-[hsl(var(--muted-ink))]">{q.date}</td>
                                <td className="px-5 py-3">{q.customer?.name || "—"}</td>
                                <td className="px-5 py-3 text-[hsl(var(--muted-ink))]">{q.model_name || q.model_id?.toUpperCase()}</td>
                                <td className="px-5 py-3 text-right font-bold">{fmtKM(q.total)}</td>
                                <td className="px-5 py-3 text-right whitespace-nowrap">
                                    <button onClick={() => download(q)} data-testid={`download-${q.quote_number}`}
                                        className="text-xs text-[hsl(var(--ink))] hover:text-[hsl(var(--accent))] underline-offset-4 hover:underline">
                                        Preuzmi PDF
                                    </button>
                                    {onReuse && (
                                        <button onClick={() => onReuse(q)} data-testid={`reuse-${q.quote_number}`}
                                            className="ml-4 text-xs text-[hsl(var(--ink))] hover:text-[hsl(var(--accent))] underline-offset-4 hover:underline">
                                            Iskoristi
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
